// ANETT HORVATH — PasswordInput Component
// Reusable password field with visibility toggle.

import { useState } from 'react';

interface PasswordInputProps {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  error?: string;
  autoFocus?: boolean;
  className?: string;
}

export default function PasswordInput({ value, onChange, placeholder = '', error, autoFocus, className }: PasswordInputProps) {
  const [visible, setVisible] = useState(false);

  const baseCls = className || 'w-full border-b border-charcoal/15 py-2.5 text-sm font-sans bg-transparent focus:border-charcoal/40 transition-colors placeholder:text-charcoal/25';

  return (
    <div className="relative">
      <input
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        autoFocus={autoFocus}
        className={`${baseCls} pr-10`}
        autoComplete="current-password"
      />
      <button
        type="button"
        onClick={() => setVisible(!visible)}
        className="absolute right-0 top-1/2 -translate-y-1/2 p-2 text-charcoal/30 hover:text-charcoal/60 transition-colors"
        tabIndex={-1}
        aria-label={visible ? 'Hide password' : 'Show password'}
      >
        {visible ? (
          // Eye-off icon
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24" />
            <line x1="1" y1="1" x2="23" y2="23" />
          </svg>
        ) : (
          // Eye icon
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
        )}
      </button>
      {error && <p className="text-xs text-burgundy font-sans mt-1">{error}</p>}
    </div>
  );
}
